import {DOM} from "./_variables";

export default {

  sliders: () => {
    (function (window, $) {

      var slider = $("#lightSlider").lightSlider({
        item:1,
        loop:true,
        slideMove:1,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:1700,
        pager: false,
        enableDrag: false,
        auto:true,
        pause: 5000,
        controls: false,
        enableTouch: false
      });

      $('.prevControls').click(function(){
        slider.goToPrevSlide();
      });

      $('.nextControls').click(function(){
        slider.goToNextSlide();
      });

      var slider2 = $("#vertical").lightSlider({
        item:1,
        loop:true,
        slideMove:1,
        vertical: true,
        verticalHeight:500,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:1700,
        pager: false,
        enableDrag: false,
        auto:true,
        pause: 5000,
        controls: false,
        enableTouch: false,
        responsive : [
          {
            breakpoint:1024,
            settings: {
              verticalHeight:'300',
              enableDrag: false
            }
          }
        ]
      });

      $('.prevControls').click(function(){
        slider2.goToPrevSlide();
      });

      $('.nextControls').click(function(){
        slider2.goToNextSlide();
      });


    })(window, jQuery);
  }
}
